import { configWithUserToken } from "../../services/config";

/** Personel listesindeki rol satırı. Not: atama kaydının id'si (userRoleId) bu yanıtta yok. */
export interface IStaffRole {
  roleId: string;
  roleName: string;
  isEnabled: boolean;
}

export interface IStaffMember {
  userId: string;
  restourantUserId?: string;
  customerName: string;
  customerSurName: string;
  customerUserName: string;
  customerEmail: string;
  customerTelNo: string;
  customerIsEnabled: boolean;
  /** Restoran bağı açık mı (bağı olmayan kuryede gelmez) */
  linkIsEnabled?: boolean;
  /** Kişinin tüm rol satırları (pasifler dahil) */
  roles: IStaffRole[];
}

export interface IRestaurantStaff {
  restourantId: string;
  restourantName: string;
  restourantIsEnabled: boolean;
  admins: IStaffMember[];
  waiters: IStaffMember[];
  drivers: IStaffMember[];
  others: IStaffMember[];
}

/**
 * Restoranın personeli, gruplu (yöneticiler / garsonlar / kuryeler / diğer).
 * RestourantAdmin yalnız kendi restoranını, SuperAdmin her restoranı okur.
 */
export const getRestaurantStaff = (restaurantId: string) =>
  configWithUserToken.get<IRestaurantStaff>(`RestourantUser/StaffByRestourantId/${restaurantId}`);
